import React from 'react';
import LazyLoad from 'react-lazy-load';

let work = () => {
  return (
    <div>
      <h3 className="uk-text-uppercase uk-text-bold">Portfolio</h3>
      <div className="uk-animation-slide-top-small">
        <div uk-grid="true">
          <div className="uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-1@s   uk-text-center">
            <LazyLoad offsetVertical={300}>
              <img src="./images/crossfitstrong.jpg" alt="CrossfitStrong"/>
            </LazyLoad>
            <p><a href="https://strongdallas.com/" className="uk-link-heading" target="_blank">CrossFit Strong</a></p>
          </div>
          <div className="uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-1@s uk-text-center">
            <LazyLoad offsetVertical={300}>
              <img src="./images/oneworldoverseas.jpg" alt="Oneworld Overseas"/>
            </LazyLoad>
            <p><a href="http://www.oneworldoverseas.com/" className="uk-link-heading" target="_blank">Oneworld Overseas</a></p>
          </div>
          <div className="uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-1@s uk-text-center">
            <LazyLoad offsetVertical={300}>
              <img src="./images/connellfoley.jpg" alt="Connellfoley"/>
            </LazyLoad>
            <p><a href="https://www.connellfoley.com/" className="uk-link-heading" target="_blank">Connellfoley</a></p>
          </div>
        </div>
        <div uk-grid="true" className="uk-flex-center">
          <div className="uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-1@s uk-text-center">
            <LazyLoad offsetVertical={300}>
              <img src="./images/vidyatrust.jpg" alt="Vidyatrust"/>
            </LazyLoad>
            <p><a href="http://www.vidyatrust.org/" className="uk-link-heading" target="_blank">Vidyatrust</a></p>
          </div>
          <div className="uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-1@s uk-text-center">
            <LazyLoad offsetVertical={300}>
              <img src="./images/neighbourcart.jpg" alt="Neighbourcart"/>
            </LazyLoad>
            <p><a href="http://dev-neighbourcart.pantheonsite.io/" className="uk-link-heading" target="_blank">Neighbour Cart</a></p>
          </div>
        </div>
      </div>
    </div>
  )
}


export default work;


// WEBPACK FOOTER //
// src/components/Work.js